import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  ClockIcon,
  HeartIcon,
  ShieldCheckIcon,
  GlobeAltIcon,
  ChatBubbleOvalLeftEllipsisIcon,
} from '@heroicons/react/24/outline';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-apollo-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-8 sm:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Apollo Noida Information */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://www.apollohospitals.com/themes/custom/apollo/assets/svg/apollo-logo.svg"
                alt="Apollo Hospitals"
                className="h-6 sm:h-8 w-auto filter brightness-0 invert"
              />
              <div>
                <h3 className="text-lg sm:text-xl font-bold">Apollo Noida</h3>
                <p className="text-sm text-apollo-light">Excellence in Healthcare</p>
              </div>
            </div>
            <p className="text-sm text-apollo-light leading-relaxed">
              Leading healthcare institution committed to providing world-class medical care 
              with advanced technology and compassionate service.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <button className="text-apollo-light hover:text-white transition-colors" aria-label="Twitter">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </button>
              <button className="text-apollo-light hover:text-white transition-colors" aria-label="Facebook">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                </svg>
              </button>
              <button className="text-apollo-light hover:text-white transition-colors" aria-label="LinkedIn">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </button>
              <button className="text-apollo-light hover:text-white transition-colors" aria-label="Pinterest">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.404-5.938 1.404-5.938s-.359-.719-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.097.118.112.222.82.403-.085.402-.277 1.402-.314 1.599-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.740-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.990-5.367 11.990-11.988C24.007 5.367 18.641.001 12.017.001z"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-lg sm:text-xl font-semibold">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPinIcon className="w-5 h-5 text-apollo-accent flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">Plot No. 251, Sector 18A</p>
                  <p className="text-sm">Noida, Uttar Pradesh 201301</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <PhoneIcon className="w-5 h-5 text-apollo-accent flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">+91-120-4885000</p>
                  <p className="text-xs text-apollo-light">24/7 Emergency Helpline</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <EnvelopeIcon className="w-5 h-5 text-apollo-accent flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">info@apollonoida.com</p>
                  <p className="text-xs text-apollo-light">General Inquiries</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <ClockIcon className="w-5 h-5 text-apollo-accent flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">24/7 Medical Services</p>
                  <p className="text-xs text-apollo-light">Emergency & Critical Care</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg sm:text-xl font-semibold">Portal Links</h3>
            <div className="space-y-2">
              <button 
                onClick={() => navigate("/directory")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Employee Directory
              </button>
              <button 
                onClick={() => navigate("/events")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Events & Activities
              </button>
              <button 
                onClick={() => navigate("/training")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Training & Development
              </button>
              <button 
                onClick={() => navigate("/tasks")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Task Management
              </button>
              <button 
                onClick={() => navigate("/documents")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Document Library
              </button>
              <button 
                onClick={() => navigate("/support")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Help & Support
              </button>
              <button 
                onClick={() => navigate("/profile")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                My Profile
              </button>
              <button 
                onClick={() => navigate("/notifications")}
                className="block text-sm text-apollo-light hover:text-white transition-colors text-left"
              >
                Notifications
              </button>
            </div>
          </div>

          {/* Emergency & Support */}
          <div className="space-y-4">
            <h3 className="text-lg sm:text-xl font-semibold">Emergency & Support</h3>
            <div className="space-y-3">
              <div className="bg-red-600 p-3 sm:p-4 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <HeartIcon className="w-5 h-5 text-white" />
                  <span className="text-sm font-semibold">Emergency Services</span>
                </div>
                <p className="text-xs text-red-100 mb-2 sm:mb-3">24/7 Emergency Care Available</p>
                <a 
                  href="tel:+911204885000" 
                  className="block bg-white text-red-600 text-center py-2 px-3 sm:px-4 rounded font-semibold hover:bg-red-50 transition-colors text-sm"
                >
                  Call Emergency: 120-4885000
                </a>
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <ChatBubbleOvalLeftEllipsisIcon className="w-4 h-4 text-apollo-accent" />
                  <button className="text-sm text-apollo-light hover:text-white transition-colors text-left">
                    Live Chat Support
                  </button>
                </div>
                <div className="flex items-center space-x-2">
                  <GlobeAltIcon className="w-4 h-4 text-apollo-accent" />
                  <button className="text-sm text-apollo-light hover:text-white transition-colors text-left">
                    Patient Portal Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Certifications & Awards */}
        <div className="py-6 sm:py-8 border-t border-apollo-secondary">
          <div className="text-center mb-6">
            <h3 className="text-lg sm:text-xl font-semibold mb-4">Certifications & Accreditations</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              <div className="flex items-center justify-center sm:justify-start space-x-2">
                <ShieldCheckIcon className="w-6 h-6 text-apollo-accent" />
                <div className="text-center sm:text-left">
                  <div className="text-sm font-semibold">ISO 27001:2013</div>
                  <div className="text-xs text-apollo-light">Information Security</div>
                </div>
              </div>
              <div className="flex items-center justify-center sm:justify-start space-x-2">
                <ShieldCheckIcon className="w-6 h-6 text-apollo-accent" />
                <div className="text-center sm:text-left">
                  <div className="text-sm font-semibold">HIPAA Compliant</div>
                  <div className="text-xs text-apollo-light">Data Protection</div>
                </div>
              </div>
              <div className="flex items-center justify-center sm:justify-start space-x-2">
                <ShieldCheckIcon className="w-6 h-6 text-apollo-accent" />
                <div className="text-center sm:text-left">
                  <div className="text-sm font-semibold">NABH Accredited</div>
                  <div className="text-xs text-apollo-light">Healthcare Quality</div>
                </div>
              </div>
              <div className="flex items-center justify-center sm:justify-start space-x-2">
                <ShieldCheckIcon className="w-6 h-6 text-apollo-accent" />
                <div className="text-center sm:text-left">
                  <div className="text-sm font-semibold">JCI Accredited</div>
                  <div className="text-xs text-apollo-light">International Standards</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-4 sm:py-6 border-t border-apollo-secondary">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-sm text-apollo-light text-center sm:text-left">
              © 2024 Apollo Hospitals Enterprise Limited. All rights reserved.
            </div>
            <div className="flex flex-wrap justify-center sm:justify-end space-x-4 sm:space-x-6 text-sm">
              <button className="text-apollo-light hover:text-white transition-colors">
                Privacy Policy
              </button>
              <button className="text-apollo-light hover:text-white transition-colors">
                Terms of Service
              </button>
              <button className="text-apollo-light hover:text-white transition-colors">
                Medical Disclaimer
              </button>
              <button className="text-apollo-light hover:text-white transition-colors">
                Accessibility
              </button>
              <button className="text-apollo-light hover:text-white transition-colors">
                Sitemap
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
